
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/admin/analytics/email",
      function () {
        return require("private-next-pages/admin/analytics/email.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/admin/analytics/email"])
      });
    }
  